import React from 'react'
import HeroBanner from '../../../react4xp/components/HeroBanner'

function HeroPart({ title, heroImageSmall, heroImageMedium, alt, buttonText, buttonHref, text, hrefExternal, bgColor }) {
  return (
    <HeroBanner
      src={heroImageMedium}
      srcMedium={heroImageSmall}
      alt={alt}
      title={title}
      text={text}
      buttonText={buttonText}
      href={buttonHref}
      hrefExternal={hrefExternal}
      bgColor={bgColor}
    >
    </HeroBanner>
  )
}

export default (props) => <HeroPart {...props} />
